import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import moment from "moment";
import "moment/locale/id";
Vue.use(Vuex);

const state = {
  sidebarShow: "responsive",
  sidebarMinimize: false,
  asideShow: false,
  darkMode: false,
  lang: "en",
  button: [],
  form: [],
  menu: [],
  table: [],
  tab: [],
  text: [],
  pagination: [],
  modal: [],
  dashboard: [],
  kpi: [],
  last_query: {},
  alert: null,
  login_token: null,
  login_role: [],
  login_data_user: {},
  mitra_aktif: null,
  koordinator_aktif: null,
  cabang_aktif: null,
  capem_aktif: null,
  role_aktif: {},
  dataStatic: {
    kategoriShift: [],
  },
  detail_karyawan: {},
  kode_client: "",
  login_time: null,
};

const mutations = {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarOpened ? false : "responsive";
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarClosed ? true : "responsive";
  },
  set(state, [variable, value]) {
    state[variable] = value;
  },
  toggle(state, variable) {
    state[variable] = !state[variable];
  },
  set_lang(state, lang) {
    state.lang = lang;
    state.table = table[lang];
    state.form = form[lang];
    state.modal = modal[lang];
    state.pagination = pagination[lang];
    state.sidebar = sidebar[lang];
    state.tab = tab[lang];
    state.text = text[lang];
    state.kpi = kpi[lang];
    state.dashboard = dashboard[lang];
  },
  set_last_query(state, route) {
    // console.log(route, "route coming");
    state.last_query[`${route.path}`] = route.query;
    // console.log(state.last_query, "hasil");
  },
  set_token(state, value) {
    // console.log(value, "set_token");
    state.login_token = value.token;
    state.login_role = value.dataRole;
    state.login_id = value.id;
    state.login_data_user = value;
    state.role_aktif = state.login_role[0];
    // state.mitra_aktif = value.mitraId ? { id: value.mitraId, namaMitra: value.namaMitra, namaApp: value.namaApp, logoApp: value.logoApp } : null;
    const x = state.role_aktif;
    state.koordinatorId = x.koordinatorId ? { id: x.koordinatorId, namaKoordinator: x.namaKoordinator } : null;
    state.cabangId = x.cabangId ? { id: x.cabangId, namaCabang: x.namaCabang } : null;
    state.capemId = x.capemId ? { id: x.capemId, namaCapem: x.namaCapem } : null;
    state.login_time = moment().add(10, "hours");
  },
  set_mitra(state, mitra) {
    // console.log(mitra)
    state.mitra_aktif = mitra;
  },
  set_login_data_user(state, value) {
    state.login_id = value.id;
    state.login_data_user = value;
  },
  logout(state) {
    state.login_token = null;
    state.login_role = [];
    state.login_id = null;
    state.login_data_user = null;
    state.role_aktif = null;
    state.mitra_aktif = null;
    state.koordinator_aktif = null;
    state.cabang_aktif = null;
    state.capem_aktif = null;
    state.kode_client = "";
    state.login_time = null;
  },
  set_alert(state, val) {
    // console.log(val, "store");
    state.alert = val;
  },
  set_dataStatic(state) {
    state.dataStatic.kategoriShift = kategoriShift;
  },
  set_detail_karyawan(state, val) {
    state.detail_karyawan = val;
  },
  set_koordinator(state, val) {
    state.koordinator_aktif = val;
  },
  set_cabang(state, val) {
    state.cabang_aktif = val;
  },
  set_capem(state, val) {
    state.capem_aktif = val;
  },
  set_role(state, val) {
    state.role_aktif = val;
  },
  set_login_role(state, val) {
    state.login_role = val;
  },
  set_kode_client(state, val) {
    state.kode_client = val;
  },
};

const getters = {
  lang(state) {
    return state.lang;
  },
  button(state) {
    return state.button;
  },
  form(state) {
    return state.form;
  },
  menu(state) {
    return state.menu;
  },
  modal(state) {
    return state.modal;
  },
  table(state) {
    return state.table;
  },
  pagination(state) {
    return state.pagination;
  },
};

const kategoriShift = [
  {
    namaKategoriShift: "Pagi",
    warna: "#8db6ea",
  },
  {
    namaKategoriShift: "Sore",
    warna: "#f3cdd4",
  },
  {
    namaKategoriShift: "Full Shift",
    warna: "#9cefd1",
  },
];

const dashboard = {
  id: {
    newApplicant: "Pelamar Baru",
    shortcut: "Jalan Pintas",
    attendance: "Kehadiran",
    requestOvertime: "Pengajuan Lembur",
    requestTimeOff: "Pengajuan Cuti",
    moreRequest: "Permintaan Lainnya",
    applicationSent: "Lamaran Terkirim",
    administrationStage: "Tahap Administrasi",
    selectionStage: "Tahap Seleksi",
    employee: "Karyawan",
    employeeOverview: "Ringkasan Karyawan",
    today: "Hari Ini",
    totalEmployee: "Total Karyawan",
    employeesOff: "Karyawan Izin",
    divisi: "Divisi",
    view: "Lihat",
    uploadVacancy: "Unggah Lowongan",
    announcement: "Pengumuman",
    profileStrength: "Kekuatan Profil",
    permanent: "Tetap",
    contract: "Kontrak",
    genderDiversity: "Keragaman Gender",
    men: "Pria",
    women: "Wanita",
    birthdayEmployee: "Karyawan Ulang Tahun",
    expiredContract: "Kontrak Habis",
    newOffer: "Penawaran Baru",
    workforceFlow: "Alur Tenaga Kerja",
    in: "Masuk",
    out: "Keluar",
    evaluation: "Beri Penilaian",
  },
  en: {
    newApplicant: "New applicant",
    shortcut: "Shortcut",
    attendance: "Attendance",
    requestOvertime: "Request Overtime",
    requestTimeOff: "Request Time Off",
    moreRequest: "More Request",
    applicationSent: "Application Sent",
    administrationStage: "Administration Stage",
    selectionStage: "Selection Stage",
    employee: "Employee",
    employeeOverview: "Employee Overview",
    today: "Today",
    totalEmployee: "Total Employee",
    employeesOff: "Employees Off",
    divisi: "Divisi",
    view: "View",
    uploadVacancy: "Upload Vacancy",
    announcement: "Announcement",
    profileStrength: "Profile Strength",
    permanent: "Permanent",
    contract: "Contract",
    genderDiversity: "Gender Diversity",
    men: "Men",
    women: "Women",
    birthdayEmployee: "Birthday Employee",
    expiredContract: "Expired Contract",
    newOffer: "New Offer",
    workforceFlow: "Workforce Flow",
    in: "In",
    out: "Out",
    evaluation: "Evaluation",
  },
};

const sidebar = {
  id: {
    dashboard: "Dashboard",
    data_master: "Data Master",
    asuransi: "Asuransi",
    mitra: "Mitra",
    dok_administrasi_pelamar: "Dok. Administrasi Pelamar",
    gaji: "Gaji",
    divisi: "Divisi",
    jabatan: "Jabatan",
    lembur: "Lembur",
    pelanggaran: "Pelanggaran",
    shift: "Shift",
    tahapan_seleksi_pelamar: "Tahapan Seleksi Pelamar",
    user: "User",
    role: "Role",
    role_user: "Role User",
    tunjangan: "Tunjangan",
    tunjangan_tidak_tetap: "Tunjangan Tidak Tetap",
    potongan: "Potongan",
    periode_penggajian: "Periode Penggajian",
    lowongan_pekerjaan: "Lowongan Pekerjaan",
    pelamar_kerja: "Pelamar Kerja",
    pelamar: "Pelamar",
    kelengkapan_pelamar: "Kelengkapan Pelamar",
    tahap_seleksi_pelamar: "Tahap Seleksi Pelamar",
    karyawan: "Karyawan",
    perjanjian_kerja: "Perjanjian Kerja",
    perintah_kerja: "Perintah Kerja",
    mutasi: "Mutasi",
    kecelakaan_kerja: "Kecelakaan Kerja",
    laporan: "Laporan",
    proyeksi_gaji: "Proyeksi Gaji",
    rekap_gaji: "Rekap Gaji",
    total_potongan: "Total Potongan",
    thr: "THR",
    absensi: "Absensi",
    rekap_absensi: "Rekap Absensi",
    pengajuan_cuti: "Pengajuan Cuti",
    pengajuan_lembur: "Pengajuan Lembur",
    perubahan_shift: "Perubahan Shift",
    surat_konfirmasi: "Surat Konfirmasi",
    penilaian_karyawan: "Penilaian Karyawan",
    jadwal: "Jadwal",
    performance_management: "Performance Management",
    import_employee_data: "Import Employee Data",
    video_tutorial_module: "Video Tutorial Module",
    surat_peringatan: "Peringatan",
    sarana: "Sarana",
    birthday: "Kartu Ulang Tahun",
    warning: "Kartu Peringatan",
    appreciation: "Kartu Penghargaan",
    announcement: "Pengumuman",
    lateFines: "Denda Absensi",
    tax: "Pengaturan Pajak",
  },
  en: {
    dashboard: "Dashboard",
    data_master: "Master Data",
    asuransi: "Insurance",
    mitra: "Partner",
    dok_administrasi_pelamar: "Applicant Administrative Docs",
    gaji: "Salary",
    divisi: "Division",
    jabatan: "Position",
    lembur: "Overtime",
    pelanggaran: "Violation",
    shift: "Shift",
    tahapan_seleksi_pelamar: "Applicant Selection Stages",
    user: "User",
    role: "Role",
    role_user: "User Role",
    tunjangan: "Allowance",
    tunjangan_tidak_tetap: "Non-Fixed Allowance",
    potongan: "Deduction",
    periode_penggajian: "Payroll Period",
    lowongan_pekerjaan: "Job Vacancy",
    pelamar_kerja: "Job Applicant",
    pelamar: "Applicant",
    kelengkapan_pelamar: "Applicant Completeness",
    tahap_seleksi_pelamar: "Applicant Selection Phase",
    karyawan: "Employee",
    perjanjian_kerja: "Work Agreement",
    perintah_kerja: "Work Order",
    mutasi: "Mutation",
    kecelakaan_kerja: "Work Accident",
    laporan: "Report",
    proyeksi_gaji: "Salary Projection",
    rekap_gaji: "Salary Recap",
    total_potongan: "Total Deduction",
    thr: "Holiday Bonus",
    absensi: "Attendance",
    rekap_absensi: "Attendance Recap",
    pengajuan_cuti: "Leave Request",
    pengajuan_lembur: "Overtime Request",
    perubahan_shift: "Shift Change",
    surat_konfirmasi: "Confirmation Letter",
    penilaian_karyawan: "Employee Evaluation",
    jadwal: "Schedule",
    performance_management: "Performance Management",
    import_employee_data: "Import Employee Data",
    video_tutorial_module: "Tutorial Video Module",
    surat_peringatan: "Warning Letter",
    sarana: "Sarana",
    birthday: "Birthday Card",
    warning: "Warning Card",
    appreciation: "Appreciation Card",
    announcement: "Annoucement",
    lateFines: "Late Attendance Fines",
    tax: "Tax Setting",
  },
};
const table = {
  id: {
    asuransi: "Asuransi",
    role: "Role",
    roleUser: "Role User",
    kategoriDenda: "kategori Denda",
    periodePenggajian: "Periode Penggajian",
    gaji: "Gaji Pokok",
    ijin: "Keterangan Ijin",
    potongan: "Potongan",
    tunjangan: "Tunjangan",
    tunjanganTidakTetap: "Tunjangan Tidak Tetap",
    jabatan: "Jabatan ",
    kelengkapanPelamar: "Data Kelengkapan Pelamar",
    // tahapanSeleksiPelamar:"Tahap Seleksi Pelamar",
    suratKonfirmasi: "Surat Konfirmasi",
    tahapanSeleksiPelamar: "Data Pelamar Yang Masuk Tahap Seleksi",
    kecelakaanKerja: "Kecelakaan Kerja",
    laporanLembur: "Laporan Lembur",
    cuti: "Cuti",
    divisi: "Divisi",
    dokAdmin: "Dokumen Administrasi Pelamar",
    kategoriPenilaian: "Kategori Penilaian",
    shift: "Shift",
    posisi: "Posisi",
    hirarki: "Hirarki",
    penilaian: "Penilaian Karyawan",
    pelanggaran: "Pelanggaran",
    pelamar: "Data Pelamar Kerja",
    user: "Pengguna",
    lowongan: "Lamaran Pekerjaan",
    karyawan: "Data Karyawan",
    mutasi: "Mutasi",
    perpanjang: "Perpanjang Kontrak",
    detailKaryawan: "Detail Data Karyawan",
    profilKaryawan: "Profil Karyawan",
    perintah: "Data Surat Perintah",
    persetujuan: "Data Surat Persetujuan",
    perjanjian: "Data Surat Perjanjian Kerja",
    pengajuanLembur: "Pengajuan Lembur",
    tahapan: "Master Tahapan Seleksi",
    tambahModal: "Tambah Data",
    perHalaman: "Per Halaman",
    cari: "Cari",
    cariHolder: "Ketik disini untuk Mencari ...",
    hapusCari: "hapus",
    tooltipEdit: "Edit Data",
    tooltipHapus: "Hapus Data",
    tooltipLunas: "Lunasi Potongan",
    tooltipReset: "Reset filter tanggal dan periode",
    tooltipRekap: "Lihat Rekapitulasi",
    kode: "Kode",
    level: "Level",
    aksi: "Aksi",
    alamatKoordinator: "Alamat Koordinator",
    koordinator: "Koordinator",
    notelp: "No. telp",
    namaKoordinator: "Koordinator",
    namaCabang: "Cabang",
    kodeCabang: "Kode",
    alamatCabang: "Alamat",
    noHpKantor: "No. Telp",
    Actions: "Actions",
    namaCapem: "Capem",
    kodeCapem: "Kode",
    alamatCapem: "Alamat",
    namaKebutuhan: "Dokumen Administrasi",
    namaPengirim: "Nama Pelamar",
    alamatPengirim: "Alamat",
    emailPengirim: "Email",
    namaLoker: "Lowongan",
    namaPosisi: "Posisi Pelamar",
    token: "TOKEN",
    tglAkhir: "Tanggal Berakhir Loker",
    namaKaryawan: "Karyawan",
    totalBerangkat: "Kehadiran",
    jumlahIjin: "Ijin",
    masukTelat: "Terlambat",
    NIK: "NIK",
    namaTanggalPengajuanCuti: "Tanggal Pengajuan",
    namaTanggalCuti: "Tanggal Cuti",
    totalCuti: "Durasi (hari)",
    namaStatusPengajuan: "Status",
    namaTanggalPengajuanLembur: "Tanggal",
    jumlahJamLembur: "Jam Lembur",
    namaNominalLembur: "Nominal Lembur",
    totalNominalLembur: "Total Lembur",
    jadwalShiftLama: "Shift Awal",
    jadwalShiftBaru: "Shift baru",
    namaTanggalPengajuanPerubahanShift: "Tanggal Pengajuan",
    namaTanggalPerubahanShift: "Tanggal Shift",
    insentif: "Insentif",
    lembur: "Lembur",
    komisi: "Komisi",
    denda: "Denda",
    thp: "THP",
    namaPeridoAwal: "Awal",
    namaPeridoAkhir: "Akhir",
    namaPotongan: "Nama Potongan",
    namaTotalPotongan: "Total Potongan",
    namaNominalGajiKaryawan: "Gaji Pokok",
    namaTanggalMulaiKerja: "Mulai Kerja",
    masaKerja: "Lama Kerja (bulan)",
    namaThr: "Tunjangan Hari Raya",
    alamatKaryawan: "Alamat",
    penempatan: "Penempatan",
    // namaDivisi: "Divisi",
    masaKontrak: "Durasi (bulan)",
    namaTanggalMulaiKontrak: "Tanggal Mulai Kontrak",
    namaTanggalSelesaiKontrak: "Habis Kontrak",
    namaStatusPerjanjian: "Jenis Kontrak",
    namaStatusPerjanjianAktif: "Status Perjanjian",
    nomorSuratPerintah: "No. Surat",
    nomorSuratPerjanjian: "No. Perjanjian",
    namaTanggalKontrak: "Tanggal Mulai Kontrak",
    masaBerlakuKontrak: "Durasi (bulan)",
    namaStatusPoolKontrakAktif: "Status",
    jenisMutasi: "Mutasi",
    namaTanggalMutasi: "Tanggal Mutasi",
    penempatanAwal: "Lokasi Lama",
    penempatanBaru: "Lokasi Baru",
    jabatanAwal: "Posisi Lama",
    jabatanBaru: "Posisi Baru",
    nomorSurat: "Nomor Surat",
    namaTanggalPerpanjang: "Tanggal Perpanjang",
    namaTanggalDibuatSurat: "Tanggal Dibuat",
    namaStatusPerpanjangKontrak: "Status",
    jadwal: "Jadwal",
    tambahJadwal: " Tambah Jadwal",
    sarana: "Tools",
    birthday: "Birthday Card",
    warning: "Surat Peringatan",
    tempatTugas: "Penempatan",
    status_persetujuan: "Status",
    namaTanggalPenilaian: "Tanggal Surat Dibuat",
    totalPoin: "Total Poin",
    announcement: "Pengumuman",
    target: "Target",
    tanggalBroadcast: "Tanggal Diumumkan",
    tanggalDibuat: "Tanggal Dibuat",
    title: "Judul",
    file: "File",
    tipe: "Tipe",
    active: "Aktif",
    lateFines: "Denda Absensi",
    nominal: "Nominal",
    deskripsi: "Deskripsi",
  },
  en: {
    asuransi: "Insurance",
    role: "Role",
    roleUser: "User Role",
    kategoriDenda: "Penalty Category",
    periodePenggajian: "Payroll Period",
    gaji: "Basic Salary",
    ijin: "Leave Notes",
    potongan: "Deduction",
    tunjangan: "Allowance",
    tunjanganTidakTetap: "Non-Fixed Allowance",
    jabatan: "Position",
    kelengkapanPelamar: "Applicant Completeness Data",
    // tahapanSeleksiPelamar:"Tahap Seleksi Pelamar",
    suratKonfirmasi: "Confirmation Letter",
    tahapanSeleksiPelamar: "Applicants in Selection Stage",
    kecelakaanKerja: "Work Accident",
    laporanLembur: "Overtime Report",
    cuti: "Leave",
    divisi: "Division",
    dokAdmin: "Applicant Administrative Documents",
    kategoriPenilaian: "Evaluation Category",
    shift: "Shift",
    posisi: "Position",
    hirarki: "Hierarchy",
    penilaian: "Employee Evaluation",
    pelanggaran: "Violation",
    pelamar: "Job Applicant Data",
    user: "User",
    lowongan: "Job Vacancy",
    karyawan: "Employee Data",
    mutasi: "Transfer",
    perpanjang: "Contract Extension",
    detailKaryawan: "Employee Details",
    profilKaryawan: "Employee Profile",
    perintah: "Assignment Letter",
    persetujuan: "Approval Letter",
    perjanjian: "Employment Agreement Letter",
    pengajuanLembur: "Overtime Request",
    tahapan: "Selection Stage Master",
    tambahModal: "Add Data",
    perHalaman: "Per Page",
    cari: "Search",
    cariHolder: "Type here to Search ...",
    hapusCari: "Clear",
    tooltipEdit: "Edit Data",
    tooltipHapus: "Delete Data",
    tooltipLunas: "Settle Deduction",
    tooltipReset: "Reset date and period filter",
    tooltipRekap: "View Recap",
    kode: "Code",
    level: "Level",
    aksi: "Action",
    alamatKoordinator: "Coordinator Address",
    koordinator: "Coordinator",
    notelp: "Phone Number",
    namaKoordinator: "Coordinator",
    namaCabang: "Branch",
    kodeCabang: "Code",
    alamatCabang: "Address",
    noHpKantor: "Office Phone Number",
    Actions: "Actions",
    namaCapem: "Sub-Branch",
    kodeCapem: "Code",
    alamatCapem: "Address",
    namaKebutuhan: "Administrative Document",
    namaPengirim: "Applicant Name",
    alamatPengirim: "Address",
    emailPengirim: "Email",
    namaLoker: "Job Vacancy",
    namaPosisi: "Applicant Position",
    token: "TOKEN",
    tglAkhir: "Job Vacancy End Date",
    namaKaryawan: "Employee",
    totalBerangkat: "Attendance",
    jumlahIjin: "Leave",
    masukTelat: "Late",
    NIK: "Employee ID",
    namaTanggalPengajuanCuti: "Leave Request Date",
    namaTanggalCuti: "Leave Date",
    totalCuti: "Duration (days)",
    namaStatusPengajuan: "Status",
    namaTanggalPengajuanLembur: "Date",
    jumlahJamLembur: "Overtime Hours",
    namaNominalLembur: "Overtime Amount",
    totalNominalLembur: "Total Overtime",
    jadwalShiftLama: "Previous Shift",
    jadwalShiftBaru: "New Shift",
    namaTanggalPengajuanPerubahanShift: "Request Date",
    namaTanggalPerubahanShift: "Shift Date",
    insentif: "Incentive",
    lembur: "Overtime",
    komisi: "Commission",
    denda: "Fine",
    thp: "Take Home Pay",
    namaPeridoAwal: "Start",
    namaPeridoAkhir: "End",
    namaPotongan: "Deduction Name",
    namaTotalPotongan: "Total Deduction",
    namaNominalGajiKaryawan: "Basic Salary",
    namaTanggalMulaiKerja: "Start Working",
    masaKerja: "Length of Service (months)",
    namaThr: "Holiday Allowance",
    alamatKaryawan: "Address",
    penempatan: "Placement",
    // namaDivisi: "Division",
    masaKontrak: "Duration (months)",
    namaTanggalMulaiKontrak: "Contract Start Date",
    namaTanggalSelesaiKontrak: "Contract End Date",
    namaStatusPerjanjian: "Contract Type",
    namaStatusPerjanjianAktif: "Contract Status",
    nomorSuratPerintah: "Letter No.",
    nomorSuratPerjanjian: "Agreement No.",
    namaTanggalKontrak: "Contract Start Date",
    masaBerlakuKontrak: "Duration (months)",
    namaStatusPoolKontrakAktif: "Status",
    jenisMutasi: "Transfer Type",
    namaTanggalMutasi: "Transfer Date",
    penempatanAwal: "Previous Location",
    penempatanBaru: "New Location",
    jabatanAwal: "Previous Position",
    jabatanBaru: "New Position",
    nomorSurat: "Letter Number",
    namaTanggalPerpanjang: "Extension Date",
    namaTanggalDibuatSurat: "Letter Created Date",
    namaStatusPerpanjangKontrak: "Status",
    jadwal: "Schedule",
    tambahJadwal: "Add Schedule",
    warning: "Warning Letter",
    announcement: "Announcement",
    target: "Target",
    tanggalBroadcast: "Broadcast Date",
    tanggalDibuat: "Created Date",
    title: "Title",
    file: "File",
    tipe: "Type",
    active: "Active",
    lateFines: "Late Fines",
    nominal: "Nominal",
    deskripsi: "Description",
  },
};

const tab = {
  id: {
    dataLoker: "Data Loker",
    syaratDokLoker: "Syarat Dok. Administrasi Loker",
    profilPelamar: "Profil Pelamar",
    riwayatPendidikan: "Riwayat Pendidikan",
    pengalamanKerja: "Pengalaman Kerja",
    lampiran: "Lampiran",
    status: "Status",
    pelamar: "Pelamar",
    pelamarditolak: "Pelamar Ditolak",
    belumditempatkan: "Belum Ditempatkan",
    ditempatkan: "Sudah Ditempatkan",
    nonaktif: "Non Aktif",
    divisi: "Divisi",
    posisi: "Posisi",
    hirarki: "Hirarki",
  },
  en: {
    dataLoker: "Job Vacancy Data",
    syaratDokLoker: "Job Vacancy Admin Document Requirements",
    profilPelamar: "Applicant Profile",
    riwayatPendidikan: "Education History",
    pengalamanKerja: "Work Experience",
    lampiran: "Attachment",
    status: "Status",
    pelamar: "Applicants",
    pelamarditolak: "Rejected Applicants",
    belumditempatkan: "Not Yet Placed",
    ditempatkan: "Placed",
    nonaktif: "Inactive",
    divisi: "Division",
    posisi: "Position",
    hirarki: "Hierarchy",
  },
};

const kpi = {
  id: {
    openModal: "Buka Form Penilaian",
    modalTitle: "Form Penilaian Kinerja",
    title: "PENILAIAN KINERJA & KONFIRMASI PERSETUJUAN",
    email: "Email",
    namaPenilai: "Nama Penilai",
    jabatanPenilai: "Jabatan Penilai",
    tempatTugas: "Tempat Tugas",
    tanggalPenilaian: "Tanggal Penilaian",
    namaKaryawan: "Nama Karyawan",
    tugasKerjaKaryawan: "Tugas Kerja Karyawan",
    aspekKepribadian: "Penilaian Aspek Kepribadian",
    penilaian1: "Kejujuran & Integritas dalam melakukan Pekerjaan",
    penilaian2: "Penampilan, etika & kelengkapan atribut seragam",
    penilaian3: "Tanggung Jawab & disiplin dalam melakukan pekerjaan",
    penilaian4: "Kepatuhan dalam melakukan pekerjaan",
    penilaian5: "Sikap & motivasi dalam melakukan pekerjaan",
    aspekKomunikasi: "Penilaian Aspek Komunikasi",
    penilaian6: "kerjasama dalam melakukan pekerjaan",
    penilaian7: "Koordinasi & berkomunikasi yang efektif",
    penilaian8: "Kemampuan untuk berinteraksi & mengungkapkan ide",
    penilaian9: "Kemampuan dalam menerima instruksi yang diberikan",
    penilaian10: "Kemampuan komunikasi yang baik untuk melayani pengguna jasa maupun rekan kerja",
    teknisPekerjaan: "Penilaian Teknis Pekerjaan",
    penilaian11: "Efektifitas & efisien si dalam melakukan pekerjaan",
    penilaian12: "Ketelitian dalam melakukan pekerjaan",
    penilaian13: "Kemampuan mencapai target Standard Operation Procedure (SOP) Perusahaan",
    penilaian14: "Inisiatif dalam menyelesaikan persoalan pekerjaan",
    penilaian15: "Antusias & sikap terhadap Pekerjaan",
    aspekProduktivitas: "Penilaian Aspek Produktivitas",
    penilaian16: "Kemmapuan dalam melakukan pekerjaan sendiri",
    penilaian17: "Kualitas, kerapian & keterampilan dalam melakukan pekerjaan",
    penilaian18: "Menunjukan minat meningkatkan pengetahuan yang baik untuk melakukan pekerjaan rutin / ekstra",
    penilaian19: "Bertanggung jawab atas sarana & prasarana perlengkapan kerja yang dipercayakan",
    penilaian20: "Kedisiplinan dalam kehadiran kerja serta disiplin dalam penggunaan waktu",
    catatanTentangKaryawan: "Catatan Tentang Karyawan",
    catatanKhusus: "Catatan dapat diisi seputar rencana usulan promosi/mutasi, prestasi karyawan, catatan khusus serta kritik",
    persetujuanPenandatanganan: "Persetujuan Penandatanganan PKWT",
    jangkaWaktuKerjaLabel: "Apabila setuju, berapa jangka waktu kerja yang diinginkan ? (bulan)",
    kosongkanForm: "Kosongkan Form",
    kirimPenilaian: "Kirim Penilaian",
    successMsg: "BERHASIL MENDAFTARKAN DATA KPI",
    // options (original texts)
    optionsRoles: ["Petugas Kebersihan", "Pengemudi", "Pesuruh", "Satpam"],
    optionsSetuju: ["Setuju", "Tidak Setuju"],
    options1: ["Dapat dipercaya (3 Poin)", "Memerlukan Pengawasan (2 Poin)", "Sangat Memerlukan Pengawasan (1 Poin)"],
    options2: ["Sangat memuaskan (3 Poin)", "Memuaskan (2 Poin)", "Tidak memuaskan (1 Poin)"],
    options3: [
      "Melakukan pekerjaan dengan maksimal dan berusahan meningkatkan Performa (3 Poin)",
      "Melakukan pekerjaan secara wajar (2 Poin)",
      "Melakukan pekerjaan dengan tidak sungguh-sungguh (1 Poin)",
    ],
    options4: ["Dapat dipercaya (3 Poin)", "Memerlukan Pengawasan (2 Poin)", "Sangat Memerlukan Pengawasan (1 Poin)"],
    options5: ["Antusias dalam melakukan pekerjaan (3 Poin)", "Melaksanakan tugas secara wajar (2 Poin)", "Acuh tak acuh dalam melakukan pekerjaan (1 Poin)"],
    options6: [
      "Selain mekakukan tugasnya, berusaha juga untuk membantu gaian / unit lain (3 Poin)",
      "Dapat bekerjasama dengan bagian / unit lain secara wajar (2 Poin)",
      "Tidak kooperatif dengan bagian / unit lain (1 Poin)",
    ],
    options7: ["Sangat memuaskan (3 Poin)", "Memuaskan (2 Poin)", "Tidak memuaskan (1 Poin)"],
    options8: [
      "Berani memulai pembicaraan dan sering menyampaikan ide yang baik(3 Poin)",
      "Berani memulai pembicaraaan dan terkadang menyampaikan ide yang baik (2 Poin)",
      "Tidak ada kemauan & cenderung acuh tak acuh dengan lingkungan (1 Poin)",
    ],
    options9: ["Sangat memuaskan (3 Poin)", "Memuaskan (2 Poin)", "Tidak memuaskan (1 Poin)"],
    options10: ["Sangat memuaskan (3 Poin)", "Memuaskan (2 Poin)", "Tidak memuaskan (1 Poin)"],
    options11: [
      "Menyelesaikan pekerjaan se-efisien mungkin, sehingga pekerjaan selesai lebih cepat (3 Poin)",
      "Menyelesaikan pekerjaan dalam tempo yang wajar (2 Poin)",
      "Menyelesaikan pekerjaan lebih lambat dari teman-teman yang tingkat pekerjaannya sama (1 Poin)",
    ],
    options12: [
      "Pekerjaan dilakukan dengan teliti & berusaha mencegah hal yang mengakikabtkan kerugian (3 Poin)",
      "Pekerjaan dilakukan dengan baik, terkadang terjadi sedikit kekurangan (2 Poin)",
      "Pekerjaan dilakukan dengan tidak teliti dan menyebabkan kerugian (1 Poin)",
    ],
    options13: ["Memenuhi SOP (3 Poin)", "Dilakukan secara wajar (2 Poin)", "Selalu dibawah SOP (1 Poin)"],
    options14: [
      "Cepat tanggap & kreatif dalam memenuhi kewajiban (3 Poin)",
      "Kadang tidak memenuhi target tetapi usaha sudah dilakukan(2 Poin)",
      "Selalu menghindar dari tugas & banyak alasan (1 Poin)",
    ],
    options15: [
      "Antusias tanpa memperhatikan waktu untuk menyelesaikan pekerjaan (3 Poin)",
      "Menerima & melaksanakan pekerjaan secara wajar (2 Poin)",
      "Acuh tak acuh dalam melaksanakan pekerjaan , bekerja atas dasar terpaksa (1 Poin)",
    ],
    options16: [
      "Semua pekerjaan diselesaikan sendiri tanpa perlu petunjuk & dapat dilepaskan sepenuhnya (3 Poin)",
      "Umumnya pekerjaan diselesaikan sendiri, hanya beberapa hal masih memerlukan bantuan (2 Poin)",
      "Pekerjaan tidak pernah dapat diselesaikan sendiri & selalu memerlukan petunjuk (1 Poin)",
    ],
    options17: ["Sangat memuaskan (3 Poin)", "Memuaskan (2 Poin)", "Tidak memuaskan (1 Poin)"],
    options18: [
      "Antusias & ada kemajuan pekerjaan sering dihasilkan (3 Poin)",
      "Terkadang ada usaha untuk memperbaiki cara kerja (2 Poin)",
      "Tidak menunjukkan kemajuan dalam melakukan tugas (1 Poin)",
    ],
    options19: ["Sangat memuaskan (3 Poin)", "Memuaskan (2 Poin)", "Tidak memuaskan (1 Poin)"],
    options20: ["Hadir lebih awal & disiplin (3 Poin)", "Terkadang terlambat hadir kerja (2 Poin)", "Sering ijin  karena urusan pribadi (1 Poin)"],
  },
  en: {
    openModal: "Open Assessment Form",
    modalTitle: "Performance Assessment Form",
    title: "PERFORMANCE ASSESSMENT & APPROVAL CONFIRMATION",
    email: "Email",
    namaPenilai: "Assessor Name",
    jabatanPenilai: "Assessor Position",
    tempatTugas: "Workplace",
    tanggalPenilaian: "Assessment Date",
    namaKaryawan: "Employee Name",
    tugasKerjaKaryawan: "Employee Job Duties",
    aspekKepribadian: "Personality Aspect Assessment",
    penilaian1: "Honesty & Integrity in performing tasks",
    penilaian2: "Appearance, ethics & completeness of uniform attributes",
    penilaian3: "Responsibility & discipline in performing tasks",
    penilaian4: "Compliance in performing tasks",
    penilaian5: "Attitude & motivation in performing tasks",
    aspekKomunikasi: "Communication Aspect Assessment",
    penilaian6: "Teamwork in performing tasks",
    penilaian7: "Coordination & effective communication",
    penilaian8: "Ability to interact & express ideas",
    penilaian9: "Ability to receive given instructions",
    penilaian10: "Good communication skills to serve clients and colleagues",
    teknisPekerjaan: "Technical Work Assessment",
    penilaian11: "Effectiveness & efficiency in performing tasks",
    penilaian12: "Accuracy in performing tasks",
    penilaian13: "Ability to achieve Company Standard Operating Procedure (SOP) targets",
    penilaian14: "Initiative in solving work problems",
    penilaian15: "Enthusiasm & attitude towards work",
    aspekProduktivitas: "Productivity Aspect Assessment",
    penilaian16: "Ability to work independently",
    penilaian17: "Quality, neatness & skills in performing tasks",
    penilaian18: "Shows interest in improving knowledge to perform routine/extra work",
    penilaian19: "Responsibility for entrusted work facilities & equipment",
    penilaian20: "Discipline in attendance and in using work time",
    catatanTentangKaryawan: "Notes About Employee",
    catatanKhusus: "Notes may include promotion/transfer proposals, employee achievements, special remarks, and criticisms",
    persetujuanPenandatanganan: "PKWT Signature Approval",
    jangkaWaktuKerjaLabel: "If agreed, what is the desired employment period? (month)",
    kosongkanForm: "Clear Form",
    kirimPenilaian: "Submit Assessment",
    successMsg: "SUCCESSFULLY REGISTERED KPI DATA",
    // options
    optionsRoles: ["Cleaning Staff", "Driver", "Messenger", "Security Guard"],
    optionsSetuju: ["Agree", "Disagree"],
    options1: ["Trustworthy (3 Points)", "Requires Supervision (2 Points)", "Requires Close Supervision (1 Point)"],
    options2: ["Very Satisfactory (3 Points)", "Satisfactory (2 Points)", "Unsatisfactory (1 Point)"],
    options3: ["Performs work to the maximum and strives to improve performance (3 Points)", "Performs work reasonably (2 Points)", "Performs work carelessly / without sincerity (1 Point)"],
    options4: ["Trustworthy (3 Points)", "Requires Supervision (2 Points)", "Requires Close Supervision (1 Point)"],
    options5: ["Enthusiastic in performing work (3 Points)", "Performs tasks reasonably (2 Points)", "Indifferent in performing work (1 Point)"],
    options6: [
      "In addition to own duties, also helps other divisions/units (3 Points)",
      "Able to cooperate with other divisions/units reasonably (2 Points)",
      "Uncooperative with other divisions/units (1 Point)",
    ],
    options7: ["Very Satisfactory (3 Points)", "Satisfactory (2 Points)", "Unsatisfactory (1 Point)"],
    options8: [
      "Initiates conversations and often shares good ideas (3 Points)",
      "Initiates conversations and sometimes shares good ideas (2 Points)",
      "Unwilling & tends to be indifferent to the environment (1 Point)",
    ],
    options9: ["Very Satisfactory (3 Points)", "Satisfactory (2 Points)", "Unsatisfactory (1 Point)"],
    options10: ["Very Satisfactory (3 Points)", "Satisfactory (2 Points)", "Unsatisfactory (1 Point)"],
    options11: [
      "Completes tasks as efficiently as possible, finishing faster (3 Points)",
      "Completes tasks at a reasonable pace (2 Points)",
      "Completes tasks slower than colleagues with the same workload (1 Point)",
    ],
    options12: ["Work is done carefully & prevents possible losses (3 Points)", "Work is done well, with minor shortcomings (2 Points)", "Work is careless and causes losses (1 Point)"],
    options13: ["Meets SOP (3 Points)", "Performed reasonably (2 Points)", "Always below SOP (1 Point)"],
    options14: ["Responsive & creative in fulfilling obligations (3 Points)", "Sometimes fails to meet targets but still tries (2 Points)", "Always avoids tasks & gives many excuses (1 Point)"],
    options15: ["Enthusiastic without regard for time to complete tasks (3 Points)", "Accepts & performs tasks reasonably (2 Points)", "Indifferent, works reluctantly / out of compulsion (1 Point)"],
    options16: [
      "All tasks completed independently without guidance, fully reliable (3 Points)",
      "Generally completes tasks independently, occasionally needs help (2 Points)",
      "Never able to complete tasks independently & always needs guidance (1 Point)",
    ],
    options17: ["Very Satisfactory (3 Points)", "Satisfactory (2 Points)", "Unsatisfactory (1 Point)"],
    options18: ["Enthusiastic & often shows progress (3 Points)", "Sometimes makes efforts to improve work (2 Points)", "Shows no progress in performing duties (1 Point)"],
    options19: ["Very Satisfactory (3 Points)", "Satisfactory (2 Points)", "Unsatisfactory (1 Point)"],
    options20: ["Arrives early & disciplined (3 Points)", "Sometimes late to work (2 Points)", "Often absent due to personal matters (1 Point)"],
  },
};

const text = {
  id: {
    konfirmasiDataLoker: "Apakah data Anda sudah sesuai?",
    aktif: "Aktif",
    tahapKelengkapanDokumen: "Tahap Kelengkapan Dokumen",
    tidakLolosKelengkapanDokumen: "Tidak Lolos Kelengkapan Dokumen",
    tidakLolosTahapan: "Tidak Lolos Tahapan",
    diterima: "Diterima",
    import_drag: "Lepaskan dan unggah file pilihan Anda",
    import_text: "Hemat waktu dan klik dengan menyeret dan melepas dokumen Anda ke jendela peramban",
  },
  en: {
    konfirmasiDataLoker: "Is your data correct?",
    aktif: "Active",
    tahapKelengkapanDokumen: "Document Completion Stage",
    tidakLolosKelengkapanDokumen: "Did Not Pass Document Completion",
    tidakLolosTahapan: "Did Not Pass the Stage",
    diterima: "Accepted",
    import_drag: "Drop and upload your selected files",
    import_text: "Save time and clicks by dragging and dropping your documents into the browser window. Upload 1 files at a time.",
  },
};
const modal = {
  id: {
    perhatian: "Perhatian...!!!",
    tambahAsuransi: "Tambah Data Master Asuransi",
    editAsuransi: "Edit Data Master Asuransi",
    tambahLembur: "Tambah Data Lembur",
    editLembur: "Edit Data Lembur",
    tambahPeriodePenggajian: "Tambah Data Master Periode Penggajian",
    editPeriodePenggajian: "Edit Data Master Periode Penggajian",
    tambahRole: "Tambah Data Master Role",
    editRole: "Edit Data Master Role",
    tambahRoleUser: "Tambah Data Master Role User",
    editRoleUser: "Edit Data Master Role User",
    tambahCuti: "Tambah Data Cuti",
    editCuti: "Edit Data Cuti",
    tambahDivisi: "Tambah Data Divisi",
    editDivisi: "Edit Data Divisi",
    tambahAdministrasiPelamar: "Tambah Data Master Administrasi Pelamar",
    editAdministrasiPelamar: "Edit Data Master Administrasi Pelamar",
    tambahKecelakaanKerja: "Tambah Data Kecelakaan Kerja",
    tambahDokAdminPelamar: "Tambah Data Master Administrasi Pelamar",
    editDokAdminPelamar: "Edit Data Master Administrasi Pelamar",
    tambahKategoriEvaluasi: "Tambah Data Master Kategori Evaluasi",
    editKategoriEvaluasi: "Edit Data Master Kategori Evaluasi",
    tambahPecat: "Tambah Data Keterangan Hapus/ Dipecat",
    editPecat: "Edit Data Keterangan Hapus/ Dipecat",
    tambahIjin: "Tambah Data Master Keterangan Ijin",
    editIjin: " Edit Data Master Keterangan Ijin",
    tambahPenilaian: "Tambah Data Master Penilaian",
    editPenilaian: "Edit Data Master Penilaian",
    tambahPosisi: "Tambah Data Master Posisi",
    editPosisi: "Edit Data Master Posisi",
    tambahPenempatan: "Tambah Data Master Perusahaan Penempatan",
    editPenempatan: "Edit Data Master Perusahaan Penempatan",
    tambahShift: "Tambah Data Master Shift",
    editShift: "Edit Data Master Shift",
    tambahTahap: "Tambah Data Master Tahapan Seleksi Pelamar",
    editTahapan: "Edit Data Master Tahapan Seleksi Pelamar",
    tambahUser: "Tambah Data Master User",
    editUser: "Edit Data Master User",
    tambahPelamar: "Tambah Data Pelamar Kerja",
    editPelamar: "Edit Data Pelamar Kerja",
    detailPelamar: "Detail Pelamar",
    editKelengkapanPelamar: "Edit Data Kelengkapan Pelamar",
    tambahKaryawan: "Tambah Data Karyawan",
    editKaryawan: "Edit Data Karyawan",
    detailKaryawan: "Detail Karyawan",
    tambahKontrak: "Tambah Data Kontrak Karyawan",
    editKontrak: "Edit Data Kontrak Karyawan",
    tambahPengajuanLembur: "Tambah Pengajuan Lembur",
    editPengajuanLembur: "Edit Pengajuan Lembur",
    editProfilKaryawan: "Edit Data Profil Karyawan",
    tambahDataPengalamanKerja: "Tambah Data Pengalaman Kerja",
    tambahDataKeluarga: "Tambah Data Keluarga",
    fotoAbsensi: "Foto Absensi Karyawan",
    fotoAbsen: "Foto Absen",
    tambahLoker: "Tambah Data Lowongan Kerja",
    konfirmasiInputLoker: "Perhatian .... !!!",
    editLoker: "Edit Data Lowongan Kerja",
    tambahPelamarKerja: "Tambah Data Pelamar Kerja",
    riwayatPelamarKerja: "Riwayat Pelamar Kerja",
    konfirmasiTerimaPelamar: "Perhatian .... !!!",
    bday: "Kirim Kartu Ucapan",
    tambahAnnouncement: "Tambah Announcement",
    kirimAppreciation: "Kirim Penghargaan",
    kirimWarning: "Kirim Peringatan",
    kirimBdayCard: "Kirim Kartu Ultah",
  },
  en: {
    perhatian: "Attention...!!!",
    tambahAsuransi: "Add Insurance Master Data",
    editAsuransi: "Edit Insurance Master Data",
    tambahLembur: "Add Overtime Data",
    editLembur: "Edit Overtime Data",
    tambahPeriodePenggajian: "Add Payroll Period Master Data",
    editPeriodePenggajian: "Edit Payroll Period Master Data",
    tambahRole: "Add Role Master Data",
    editRole: "Edit Role Master Data",
    tambahRoleUser: "Add User Role Master Data",
    editRoleUser: "Edit User Role Master Data",
    tambahCuti: "Add Leave Data",
    editCuti: "Edit Leave Data",
    tambahDivisi: "Add Division Data",
    editDivisi: "Edit Division Data",
    tambahAdministrasiPelamar: "Add Applicant Administration Master Data",
    editAdministrasiPelamar: "Edit Applicant Administration Master Data",
    tambahKecelakaanKerja: "Add Work Accident Data",
    tambahDokAdminPelamar: "Add Applicant Administration Master Data",
    editDokAdminPelamar: "Edit Applicant Administration Master Data",
    tambahKategoriEvaluasi: "Add Evaluation Category Master Data",
    editKategoriEvaluasi: "Edit Evaluation Category Master Data",
    tambahPecat: "Add Termination/Dismissal Description Data",
    editPecat: "Edit Termination/Dismissal Description Data",
    tambahIjin: "Add Permission Description Master Data",
    editIjin: "Edit Permission Description Master Data",
    tambahPenilaian: "Add Evaluation Master Data",
    editPenilaian: "Edit Evaluation Master Data",
    tambahPosisi: "Add Position Master Data",
    editPosisi: "Edit Position Master Data",
    tambahPenempatan: "Add Placement Company Master Data",
    editPenempatan: "Edit Placement Company Master Data",
    tambahShift: "Add Shift Master Data",
    editShift: "Edit Shift Master Data",
    tambahTahap: "Add Applicant Selection Stage Master Data",
    editTahapan: "Edit Applicant Selection Stage Master Data",
    tambahUser: "Add User Master Data",
    editUser: "Edit User Master Data",
    tambahPelamar: "Add Job Applicant Data",
    editPelamar: "Edit Job Applicant Data",
    detailPelamar: "Applicant Details",
    editKelengkapanPelamar: "Edit Applicant Completeness Data",
    tambahKaryawan: "Add Employee Data",
    editKaryawan: "Edit Employee Data",
    detailKaryawan: "Employee Details",
    tambahKontrak: "Add Employee Contract Data",
    editKontrak: "Edit Employee Contract Data",
    tambahPengajuanLembur: "Add Overtime Request",
    editPengajuanLembur: "Edit Overtime Request",
    editProfilKaryawan: "Edit Employee Profile Data",
    tambahDataPengalamanKerja: "Add Work Experience Data",
    tambahDataKeluarga: "Add Family Data",
    fotoAbsensi: "Employee Attendance Photo",
    fotoAbsen: "Absence Photo",
    tambahLoker: "Add Job Vacancy Data",
    konfirmasiInputLoker: "Attention .... !!!",
    editLoker: "Edit Job Vacancy Data",
    tambahPelamarKerja: "Add Job Applicant Data",
    riwayatPelamarKerja: "Job Applicant History",
    konfirmasiTerimaPelamar: "Attention .... !!!",
    bday: "Send Bday Card",
    tambahAnnouncement: "Add Announcement",
    kirimAppreciation: "Send Appreciation",
    kirimWarning: "Send Warning",
    kirimBdayCard: "Send Bday Card",
  },
};
const form = {
  id: {
    asuransi: "Asuransi",
    namaAsuransi: "Nama Asuransi",
    namaGaji: "Nama Gaji Pokok",
    nominalGaji: "Nominal Gaji Pokok",
    nominalGajiBaru: "Nominal Gaji Pokok Baru",
    periodePenggajian: "Periode Penggajian",
    namaLembur: "Nama Lembur",
    nominalLembur: "Nominal Lembur",
    cuti: "Cuti",
    divisi: "Divisi",
    namaDokumen: "Nama Dokumen",
    tanggalJamKecelakaan: "Tanggal - Jam Kecelakaan Kerja",
    karyawan: "Karyawan",
    lokasiKejadian: "Lokasi Kejadian",
    bagianLuka: "Bagian Luka",
    kronologi: "Kronologi Kejadian",
    isiKronologi: "Masukkan kronologi kejadian...",
    statusKronologi: "Status Kronologi Kejadian",
    keterangan: "Keterangan",
    isiKeterangan: "Masukkan keterangan tambahan...",
    kategoriPenilaian: "Kategori Penilaian",
    KeteranganPecat: "Keterangan Hapus / Dipecat",
    keteranganIjin: "Keterangan Ijin",
    penilaian: "Penilaian",
    posisi: "Posisi",
    kode: "Kode",
    perusahaan: "Perusahaan",
    alamat: "Alamat",
    telp: "No. Telepon",
    email: "Email",
    koorLintang: "Koordinat Lintang",
    koorBujur: "Koordinat Bujur",
    pic: "PIC",
    telpPIC: "No. Telepon PIC",
    emailPIC: "Email PIC",
    JabatanPIC: "Jabatan PIC",
    kategoriShift: "Kategori Shift",
    jamMasuk: "Jam Masuk",
    jamPulang: "Jam Pulang",
    tahapan: "Tahapan",
    namaPengguna: "Nama Pengguna",
    emailPengguna: "Email Pengguna",
    username: "Username",
    password: "Password",
    NIP: "NIP",
    judul: "Judul",
    tanggalAkhirLowongan: "Tanggal Akhir Lowongan",
    syaratDokAdministrasi: "Syarat Dok. Administrasi",
    posisiDilamar: "Posisi Yang Dilamar",
    fileCV: " File CV",
    tinggiBadan: "Tinggi Badan",
    beratBadan: "Berat Badan",
    agama: "Agama",
    kebangsaan: "Kebangsaan",
    jenisKelamin: "JenisKelamin",
    tempatLahir: "Tempat Lahir",
    tanggalLahir: "Tanggal Lahir",
    noTelp: "No. Telepon/HP",
    namaPasangan: "Nama Suami/Istri",
    noKTPPasangan: "No. KTP Suami/Istri",
    alamatPasangan: "Alamat Suami/Istri",
    jumlahAnak: "Jumlah Anak",
    anak1: "Anak 1",
    anak2: "Anak 2",
    fotoProfil: "Foto Profil",
    fotoKK: "Foto KK",
    potongan: "Potongan",
    nomorAsuransi: "nomor",
    dataKaryawan: "Data Karyawan",
    tanggalMulaiKontrak: "Tanggal Mulai Kontrak",
    durasiKontrak: "Durasi Kontrak(bulan)",
    detailKontrak: "Detail Kontrak",
    nomorPassport: "Nomor Passport",
    mitra: "Mitra",
    koordinator: "Koordinator",
    cabang: "Cabang",
    capem: "Capem",
    statusKerja: "Status Kerja",
    pendidikan: "Pendidikan Terakhir",
    usia: "Usia",
    minUsia: "min (tahun)",
    maxUsia: "max (tahun)",
    masaKerja: "Masa Kerja",
    minMasaKerja: "min (tahun)",
    maxMasaKerja: "max (tahun)",
    pilihMitra: "-- Pilih Mitra --",
    pilihKoordinator: "-- Pilih Koordinator --",
    pilihCabang: "-- Pilih Cabang --",
    pilihCapem: "-- Pilih Capem --",
    pilihDivisi: "-- Pilih Divisi --",
    pilihPosisi: "-- Pilih Posisi --",
    cetakList: "Cetak List",
    reset: "Reset",
    nip: "NIP",
    nomorTelepon: "Nomor Telepon",
    placeholderKaryawan: "-- pilih karyawan --",
    placeholderMitra: "-- pilih mitra --",
    kitas: "Nomor KITAS",
    imta: "Nomor IMTA",
    masaBerlaku: "Masa Berlaku",
    statusAbsen: "Status Absen",
    NIK: "NIP",
    namaKaryawan: "Nama Karyawan",
    nomorKTPKaryawan: "No. KTP",
    namaPosisi: "Posisi",
    tinggiBadanKaryawan: "Tinggi Badan",
    beratBadanKaryawan: "Berat Badan",
    golonganDarahKaryawan: "Golongan Darah",
    agamaKaryawan: "Agama",
    kebangsaanKaryawan: "Kebangsaan",
    jenisKelaminKaryawan: "Jenis Kelamin",
    tempatLahirKaryawan: "Tempat Lahir",
    tanggalLahirKaryawan: "Tanggal Lahir",
    noHpKaryawan: "No. Telepon/Hp",
    SIM: "SIM",
    emailKaryawan: "Email",
    kotaDomisili: "Kota Domisili",
    alamatKaryawan: "Alamat",
    statusKaryawan: "Status Pernikahan",
    statusKerjaKaryawan: "Status Karyawan",
    tanggalMulaiKerja: "Tanggal Mulai Kerja",
    nomorRekening: "No. Rekening",
    namaBank: "Nama Bank",
    nomorBpjsKetenagakerjaan: "No. BPJS Ketenagakerjaan",
    nomorBpjsKesehatan: "No. BPJS Kesehatan",
    nomor: "Nomor",
    tingkatPendidikan: "Tingkat Pendidikan",
    namaSekolah: "Nama Sekolah",
    tahunKelulusan: "Tahun Kelulusan",
    jurusan: "Jurusan",
    jabatan: "Jabatan",
    tahun: "Tahun",
    nama: "Nama",
    nomorKTP: "Nomor KTP",
    statusDalamKeluarga: "Status Dalam Keluarga",
    statusAsuransi: "Status Asuransi",
    periode: "Periode",
    bulanTahun: "Bulan - Tahun",
    absensiKedatangan: "Data Absensi Kedatangan",
    berangkat: "Berangkat",
    dinas: "DINAS",
    cutiHamil: "CUTI HAMIL",
    ijin: "IJIN",
    sakit: "SAKIT",
    alpha: "ALPHA / MANGKIR",
    keluargaMeninggal: "KELUARGA MENINGGAL",
    istriMelahirkan: "ISTRI MELAHIRKAN",
    menikah: "MENIKAH",
    jatahLibur: "JATAH LIBUR",
    tanggal: "Tanggal",
    jenisPelanggaran: "Jenis Pelanggaran",
    sumberPelanggaran: "Sumber Pelanggaran",
    keteranganPelanggaran: "Keterangan Pelanggaran",
    gajiPokok: "Gaji Pokok",
    nominalGajiPokok: "Nominal Gaji Pokok",
    dataTunjangan: "Data Tunjangan",
    namaTunjangan: "Nama Tunjangan",
    nominalTunjangan: "Nominal Tunjangan",
    tambahData: "Tambah Data",
    dataPotongan: "Data Potongan",
    namaPotongan: "Nama Potongan",
    jenisPotongan: "Jenis Potongan",
    nominalPotongan: "Nominal Potongan",
    lunas: "Lunas",
    berjalan: "Berjalan",
    modalLunasTitle: "Pelunasan Potongan",
    konfirmasiLunas: "Apakah anda yakin akan melunasi potongan a.n",
    batal: "Batal",
    yakin: "Yakin",
    simpan: "Simpan",
    tunggu: "Mohon Tunggu",
    ya: "Ya",
    tidak: "Tidak",
    delete_message: "Apakah anda yakin akan menghapus data ini ?",
    hari: "hari",
    judulInsentif: "Data Insentif",
    namaInsentif: "Nama Insentif",
    nominalInsentif: "Nominal Insentif",
    maksimalInsentif: "Maksimal Insentif",
    placeholderPeriode: "-- Pilih Periode --",
    judulTHP: "Total Take Home Pay",
    tunjangan: "Tunjangan",
    insentif: "Insentif",
    lembur: "Lembur",
    komisi: "Komisi",
    potonganAsuransi: "Potongan Asuransi",
    potonganDenda: "Potongan Denda",
    totalTHP: "Total Take Home Pay",
    umurMinimal: "Umur Minimal",
    umurMaksimal: "Umur Maksimal",
    tanggalAkhir: "Tanggal Akhir Lowongan",
    fotoPoster: "Foto Poster",
    pilihDivisiPlaceholder: "-- Pilih Divisi --",
    pilihPosisiPlaceholder: "-- Pilih Posisi --",
    pilihDokumenAdministrasiPlaceholder: "-- Pilih Dokumen Administrasi --",
    tambahkan: "Tambahkan",
    divisiPlaceholder: "-- Pilih Divisi --",
    posisiPlaceholder: "-- Pilih Posisi --",
    pelamar: "Pelamar",
    posisiYangDilamar: "Posisi Yang Dilamar",
    namaLengkap: "Nama Lengkap",
    tanggalLahirPlaceholder: "Pilih Tanggal Lahir",
    perHalaman: "Per Halaman",
    cari: "Cari",
    ketikPencarian: "Ketik disini untuk mencari ...",
    hapus: "Hapus",
    tanggalMasukLamaran: "Tanggal Masuk lamaran",
    noKTP: "Nomor KTP",
    tahunLulus: "Tahun Kelulusan",
    namaPerusahaan: "Nama Perusahaan",
    uploadFile: "Upload File",
    lihatFile: "Lihat File",
    statusPernikahan: "Status Pernikahan",
    noTelepon: "No. Telepon/Hp",
    syaratDokumen: "Syarat Dokumen Administrasi",
    file: "File",
    checklist: "Checklist",
    tidakAdaFile: "Tidak Ada File",
    statusKelengkapanPelamar: "Status Kelengkapan Pelamar",
    modalTitleKonfirmasi: "Perhatian .... !!!",
    modalBodyKonfirmasi: "Apakah pilihan Anda sudah sesuai?",
    detailPelamar: "Detail Pelamar",
    profilPelamar: "Profil Pelamar",
    riwayatPendidikan: "Riwayat Pendidikan",
    pengalamanKerja: "Pengalaman Kerja",
    lampiran: "Lampiran",
    status: "Status",
    kirim: "Kirim",
    target: "target",
    broadcastDate: "Tanggal Pengumuman",
    sebelumnya: "Sebelumnya",
    selanjutnya: "Selanjutnya",
    pesan: "Pesan",
  },
  en: {
    asuransi: "Insurance",
    namaAsuransi: "Insurance Name",
    namaGaji: "Basic Salary Name",
    nominalGaji: "Basic Salary Amount",
    nominalGajiBaru: "New Basic Salary Amount",
    periodePenggajian: "Payroll Period",
    namaLembur: "Overtime Name",
    nominalLembur: "Overtime Amount",
    cuti: "Leave",
    divisi: "Division",
    namaDokumen: "Document Name",
    tanggalJamKecelakaan: "Date - Time of Work Accident",
    karyawan: "Employee",
    lokasiKejadian: "Incident Location",
    bagianLuka: "Injured Area",
    kronologi: "Incident Chronology",
    isiKronologi: "Enter the chronology of the incident...",
    statusKronologi: "Incident Chronology Status",
    keterangan: "Description",
    isiKeterangan: "Enter additional description...",
    kategoriPenilaian: "Evaluation Category",
    KeteranganPecat: "Termination/Dismissal Description",
    keteranganIjin: "Permission Description",
    penilaian: "Evaluation",
    posisi: "Position",
    kode: "Code",
    perusahaan: "Company",
    alamat: "Address",
    telp: "Phone Number",
    email: "Email",
    koorLintang: "Latitude Coordinate",
    koorBujur: "Longitude Coordinate",
    pic: "PIC",
    telpPIC: "PIC Phone Number",
    emailPIC: "PIC Email",
    JabatanPIC: "PIC Position",
    kategoriShift: "Shift Category",
    jamMasuk: "Clock In",
    jamPulang: "Clock Out",
    tahapan: "Stage",
    namaPengguna: "User Name",
    emailPengguna: "User Email",
    username: "Username",
    password: "Password",
    NIP: "Employee ID",
    judul: "Title",
    tanggalAkhirLowongan: "Job Vacancy End Date",
    syaratDokAdministrasi: "Administrative Document Requirement",
    posisiDilamar: "Applied Position",
    fileCV: "CV File",
    tinggiBadan: "Height",
    beratBadan: "Weight",
    agama: "Religion",
    kebangsaan: "Nationality",
    jenisKelamin: "Gender",
    tempatLahir: "Place of Birth",
    tanggalLahir: "Date of Birth",
    noTelp: "Phone Number",
    namaPasangan: "Spouse's Name",
    noKTPPasangan: "Spouse's ID Number",
    alamatPasangan: "Spouse's Address",
    jumlahAnak: "Number of Children",
    anak1: "Child 1",
    anak2: "Child 2",
    fotoProfil: "Profile Photo",
    fotoKK: "Family Card Photo",
    potongan: "Deductions",
    nomorAsuransi: "Number",
    dataKaryawan: "Employee Data",
    tanggalMulaiKontrak: "Contract Start Date",
    durasiKontrak: "Contract Duration (months)",
    detailKontrak: "Contract Details",
    nomorPassport: "Passport Number",
    mitra: "Partner",
    koordinator: "Coordinator",
    cabang: "Branch",
    capem: "Capem",
    statusKerja: "Work Status",
    pendidikan: "Latest Education",
    usia: "Age",
    minUsia: "min (years)",
    maxUsia: "max (years)",
    masaKerja: "Work Duration",
    minMasaKerja: "min (years)",
    maxMasaKerja: "max (years)",
    pilihMitra: "-- Select Partner --",
    pilihKoordinator: "-- Select Coordinator --",
    pilihCabang: "-- Select Branch --",
    pilihCapem: "-- Select Capem --",
    pilihDivisi: "-- Select Division --",
    pilihPosisi: "-- Select Position --",
    cetakList: "Print List",
    reset: "Reset",
    nip: "Employee ID",
    nomorTelepon: "Phone Number",
    placeholderKaryawan: "-- select employee --",
    placeholderMitra: "-- select partner --",
    kitas: "KITAS Number",
    imta: "IMTA Number",
    masaBerlaku: "Validity Period",
    statusAbsen: "Absence Status",
    NIK: "Employee ID",
    namaKaryawan: "Employee Name",
    nomorKTPKaryawan: "ID Number",
    namaPosisi: "Position",
    tinggiBadanKaryawan: "Height",
    beratBadanKaryawan: "Weight",
    golonganDarahKaryawan: "Blood Type",
    agamaKaryawan: "Religion",
    kebangsaanKaryawan: "Nationality",
    jenisKelaminKaryawan: "Gender",
    tempatLahirKaryawan: "Place of Birth",
    tanggalLahirKaryawan: "Date of Birth",
    noHpKaryawan: "Phone Number",
    SIM: "Driver's License",
    emailKaryawan: "Email",
    kotaDomisili: "City of Residence",
    alamatKaryawan: "Address",
    statusKaryawan: "Marital Status",
    statusKerjaKaryawan: "Employment Status",
    tanggalMulaiKerja: "Work Start Date",
    nomorRekening: "Bank Account Number",
    namaBank: "Bank Name",
    nomorBpjsKetenagakerjaan: "Employment BPJS Number",
    nomorBpjsKesehatan: "Health BPJS Number",
    nomor: "Number",
    tingkatPendidikan: "Education Level",
    namaSekolah: "School Name",
    tahunKelulusan: "Graduation Year",
    jurusan: "Major",
    jabatan: "Position",
    tahun: "Year",
    nama: "Name",
    nomorKTP: "ID Number",
    statusDalamKeluarga: "Family Status",
    statusAsuransi: "Insurance Status",
    periode: "Period",
    bulanTahun: "Month - Year",
    absensiKedatangan: "Attendance Data",
    berangkat: "Present",
    dinas: "ASSIGNED",
    cutiHamil: "MATERNITY LEAVE",
    ijin: "PERMISSION",
    sakit: "SICK",
    alpha: "UNEXCUSED / ABSENT",
    keluargaMeninggal: "FAMILY DEATH",
    istriMelahirkan: "WIFE GAVE BIRTH",
    menikah: "MARRIED",
    jatahLibur: "LEAVE ENTITLEMENT",
    tanggal: "Date",
    jenisPelanggaran: "Violation Type",
    sumberPelanggaran: "Violation Source",
    keteranganPelanggaran: "Violation Description",
    gajiPokok: "Basic Salary",
    nominalGajiPokok: "Basic Salary Amount",
    dataTunjangan: "Allowance Data",
    namaTunjangan: "Allowance Name",
    nominalTunjangan: "Allowance Amount",
    tambahData: "Add Data",
    dataPotongan: "Deduction Data",
    namaPotongan: "Deduction Name",
    jenisPotongan: "Deduction Type",
    nominalPotongan: "Deduction Amount",
    lunas: "Paid Off",
    berjalan: "Ongoing",
    modalLunasTitle: "Deduction Payment",
    konfirmasiLunas: "Are you sure you want to pay off the deduction for",
    batal: "Cancel",
    yakin: "Confirm",
    simpan: "Save",
    tunggu: "Please Wait",
    ya: "Yes",
    tidak: "No",
    delete_message: "Are you sure you want to delete this data?",
    hari: "days",
    judulInsentif: "Incentive Data",
    namaInsentif: "Incentive Name",
    nominalInsentif: "Incentive Amount",
    maksimalInsentif: "Maximum Incentive",
    placeholderPeriode: "-- Select Period --",
    judulTHP: "Total Take Home Pay",
    tunjangan: "Allowance",
    insentif: "Incentive",
    lembur: "Overtime",
    komisi: "Commission",
    potonganAsuransi: "Insurance Deduction",
    potonganDenda: "Penalty Deduction",
    totalTHP: "Total Take Home Pay",
    umurMinimal: "Minimum Age",
    umurMaksimal: "Maximum Age",
    tanggalAkhir: "Job Vacancy End Date",
    fotoPoster: "Poster Photo",
    pilihDivisiPlaceholder: "-- Select Division --",
    pilihPosisiPlaceholder: "-- Select Position --",
    pilihDokumenAdministrasiPlaceholder: "-- Select Administrative Document --",
    tambahkan: "Add",
    divisiPlaceholder: "-- Select Division --",
    posisiPlaceholder: "-- Select Position --",
    pelamar: "Applicant",
    posisiYangDilamar: "Applied Position",
    namaLengkap: "Full Name",
    tanggalLahirPlaceholder: "Select Birth Date",
    perHalaman: "Per Page",
    cari: "Search",
    ketikPencarian: "Type here to search ...",
    hapus: "Delete",
    tanggalMasukLamaran: "Application Entry Date",
    noKTP: "ID Number",
    tahunLulus: "Graduation Year",
    namaPerusahaan: "Company Name",
    uploadFile: "Upload File",
    lihatFile: "View File",
    statusPernikahan: "Marital Status",
    noTelepon: "Phone Number",
    syaratDokumen: "Administrative Document Requirements",
    file: "File",
    checklist: "Checklist",
    tidakAdaFile: "No File Available",
    statusKelengkapanPelamar: "Applicant Completeness Status",
    modalTitleKonfirmasi: "Attention .... !!!",
    modalBodyKonfirmasi: "Is your choice correct?",
    detailPelamar: "Applicant Details",
    profilPelamar: "Applicant Profile",
    riwayatPendidikan: "Education History",
    pengalamanKerja: "Work Experience",
    lampiran: "Attachment",
    status: "Status",
    kirim: "Send",
    target: "target",
    broadcastDate: "Broadcast Date",
    sebelumnya: "Previous",
    selanjutnya: "Next",
    pesan: "Message",
  },
};
const pagination = {
  id: {
    perHalaman: "Per Halaman",
    label_tampilkan: "menampilkan",
    label_sampai: "sampai",
    label_dari: "dari",
    label_entri: "data",
  },
  en: {
    perHalaman: "Per Page",
    label_tampilkan: "showing",
    label_sampai: "to",
    label_dari: "from",
    label_entri: "data",
  },
};

export default new Vuex.Store({
  state,
  mutations,
  getters,
  plugins: [
    createPersistedState({
      key: "eatlah",
    }),
  ],
});
